import { ServerSettings } from '@src/infrastructure/serverSettings';
import { HttpClient } from '@src/infrastructure/httpClient/index';
import { ErrorCodes } from './errorCodes';
import { InformationCodes } from './informationCodes';
import * as ApiModels from './loggingApiModels';
import { routes } from "@src/infrastructure/routes";

export { ApiModels };

export class LoggingService {
    private readonly httpClient: HttpClient;

    constructor(serverSettings: ServerSettings){
        this.httpClient = new HttpClient(serverSettings);
    }

    public log(request: ApiModels.LogErrorApiRequestModel): Promise<void> {
        return this.httpClient.post(routes.api.logging.logError, request);
    }
}